import { Spin } from 'm-ui';
import React from 'react';
import style from './style.module.less';

interface IProps {
    style?: React.CSSProperties;
}
const Loading: React.FC<IProps> = (props) => {
    return <Spin spinning className={style.loading} style={{ ...props?.style }} />;
};

export default React.memo(Loading);
